/* PDZ Product Finder — see sections/pdz-finder.liquid */
(function () {
  'use strict';
  var root = document.querySelector('[data-pdz-finder]');
  if (!root || root.__pdz) return;
  root.__pdz = true;

  var BUDGETS = [];
  try { BUDGETS = JSON.parse(root.getAttribute('data-budgets') || '[]').filter(function (n) { return n > 0; }); } catch (e) {}
  var HIDE = (root.getAttribute('data-hide-types') || '').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
  var P = { type: 'filter.p.product_type', gte: 'filter.v.price.gte', lte: 'filter.v.price.lte' };
  var COLOUR_RX = /color-pattern|colou?r/i;
  var STEPS = 4;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var nf = function (n) { return Number(n || 0).toLocaleString('en-ZA'); };
  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); };

  /* ---------- state (kept in the URL so links can be shared) ---------- */
  var state = { where: '', type: [], price: '', colour: [], step: 0 };
  var colourParam = '';
  (function readUrl() {
    var q = new URLSearchParams(location.search);
    state.where = q.get('in') || '';
    state.type = q.getAll('type');
    state.price = q.get('price') || '';
    state.colour = q.getAll('colour');
    var st = parseInt(q.get('step'), 10);
    state.step = isNaN(st) || !state.where ? 0 : Math.max(0, Math.min(STEPS, st));
  })();
  function writeUrl() {
    var q = new URLSearchParams();
    if (state.where) q.set('in', state.where);
    state.type.forEach(function (t) { q.append('type', t); });
    if (state.price) q.set('price', state.price);
    state.colour.forEach(function (c) { q.append('colour', c); });
    if (state.step) q.set('step', state.step);
    var s = q.toString();
    history.replaceState(null, '', location.pathname + (s ? '?' + s : ''));
  }

  /* Shopify filter query for a state. "skip" leaves one answer out (to count its options). */
  function filterQuery(s, skip) {
    var q = new URLSearchParams();
    if (skip !== 'type') s.type.forEach(function (t) { q.append(P.type, t); });
    if (s.price && skip !== 'price') {
      var r = s.price.split('-');
      if (r[0]) q.set(P.gte, r[0]);
      if (r[1]) q.set(P.lte, r[1]);
    }
    if (colourParam && skip !== 'colour') s.colour.forEach(function (c) { q.append(colourParam, c); });
    return q;
  }
  function withState(patch) { var s = JSON.parse(JSON.stringify(state)); for (var k in patch) s[k] = patch[k]; return s; }

  /* ---------- data from Shopify (cached) ---------- */
  var cache = {};
  function load(s, skip) {
    var q = filterQuery(s, skip);
    q.set('sort_by', 'best-selling');
    q.set('section_id', 'pdz-finder-data');
    var url = '/collections/' + encodeURIComponent(s.where) + '?' + q.toString();
    if (cache[url]) return cache[url];
    cache[url] = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var tag = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pdz-fd]');
        var d = tag ? JSON.parse(tag.textContent) : { count: 0, filters: [] };
        d.byParam = {};
        (d.filters || []).forEach(function (f) {
          d.byParam[f.param] = f;
          /* Shopify gives some filter values HTML-escaped ("&amp;"). Send the plain text back, or the filter matches nothing. */
          (f.values || []).forEach(function (v) { v.value = unescapeHtml(v.value); v.label = unescapeHtml(v.label); });
          if (!colourParam && f.values && COLOUR_RX.test(f.param + ' ' + f.label)) colourParam = f.param;
        });
        return d;
      })
      .catch(function (e) { delete cache[url]; throw e; });
    return cache[url];
  }
  function unescapeHtml(t) {
    if (t == null || String(t).indexOf('&') === -1) return t;
    var el = document.createElement('textarea'); el.innerHTML = t; return el.value;
  }
  function values(d, param) { var f = d && d.byParam[param]; return f && f.values ? f.values : []; }

  /* ---------- animated numbers ---------- */
  function countTo(el, to) {
    if (!el) return;
    var from = Number(el.getAttribute('data-n') || String(el.textContent).replace(/\D/g, '') || 0);
    el.setAttribute('data-n', to);
    if (reduce || from === to) { el.textContent = nf(to); return; }
    var t0 = performance.now(), dur = 650;
    (function tick(t) {
      var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
      el.textContent = nf(Math.round(from + (to - from) * e));
      if (p < 1) requestAnimationFrame(tick);
    })(t0);
  }

  var TOTAL = Number(root.getAttribute('data-total')) || 0;
  var meter = $('[data-meter]'), meterBar = $('[data-meter-bar]'), meterLbl = $('[data-meter-lbl]'), meterSub = $('[data-meter-sub]');
  var dockNum = $('[data-dock-num]'), dockWord = $('[data-dock-word]');
  var lastCount = 0, reqId = 0;
  function refreshCount() {
    var my = ++reqId;
    if (!state.where) {
      meterLbl.textContent = 'Products to choose from';
      countTo(meter, TOTAL); meterBar.style.width = '100%';
      meterSub.textContent = 'Answer a few questions and we narrow it down for you.';
      return Promise.resolve(null);
    }
    return load(state).then(function (d) {
      if (my !== reqId) return d;
      if (!TOTAL || d.count > TOTAL) TOTAL = Math.max(TOTAL, d.count);
      lastCount = d.count;
      var picked = state.where || state.type.length || state.price || state.colour.length;
      meterLbl.textContent = picked ? 'Products that match' : 'Products to choose from';
      countTo(meter, d.count);
      countTo(dockNum, d.count);
      if (dockWord) dockWord.textContent = d.count === 1 ? 'product matches' : 'products match';
      var pct = TOTAL ? Math.max(3, Math.round(100 * d.count / TOTAL)) : 100;
      meterBar.style.width = (picked ? pct : 100) + '%';
      meterSub.textContent = !picked ? 'Answer a few questions and we narrow it down for you.'
        : d.count === 0 ? 'No match yet. Remove an answer to see more.'
        : d.count <= 24 ? 'A short list. Have a look at your matches.'
        : 'Keep going to narrow it down, or see your matches now.';
      return d;
    });
  }

  /* ---------- steps ---------- */
  var panels = $$('[data-step]');
  var dock = $('[data-dock]');
  var nextLbl = $('[data-next-lbl]');
  var dockStep = $('[data-dock-step]'), dockBar = $('[data-dock-bar]');
  var stepBtns = $$('.pdz-fd__steps button');
  var available = { 1: true, 2: true, 3: true }; // a step without data is skipped

  function show(step, opts) {
    opts = opts || {};
    if (step > 0 && step < STEPS && !available[step]) { step += (opts.dir || 1); return show(step, opts); }
    step = Math.max(0, Math.min(STEPS, step));
    if (!state.where) step = 0;
    state.step = step;
    writeUrl();
    panels.forEach(function (p) {
      var on = Number(p.getAttribute('data-step')) === step;
      if (on && p.hidden) {
        p.hidden = false;
        if (!reduce) { p.classList.remove('is-in'); void p.offsetWidth; p.classList.add('is-in'); }
      } else if (!on) p.hidden = true;
    });
    stepBtns.forEach(function (b, i) {
      var li = b.parentNode;
      li.classList.toggle('is-current', i === step);
      li.classList.toggle('is-done', i < step || (step === STEPS));
      b.disabled = i > step && step !== STEPS;
      b.setAttribute('aria-current', i === step ? 'step' : 'false');
    });
    root.classList.toggle('is-results', step === STEPS);
    dock.hidden = step === 0 || step === STEPS;
    document.documentElement.classList.toggle('pdz-fd-docked', !dock.hidden);
    var names = stepBtns.map(function (b) { return ((b.querySelector('em') || {}).textContent || '').trim(); });
    var nxt = step + 1;
    while (nxt < STEPS && !available[nxt]) nxt++;
    nextLbl.innerHTML = nxt >= STEPS ? 'Show my matches' : 'Next<span class="pdz-fd__nx">: ' + esc(names[nxt]) + '</span>';
    if (dockStep) dockStep.innerHTML = 'Step ' + (step + 1) + ' of ' + STEPS + '<span class="pdz-fd__nx"> · ' + esc(names[step]) + '</span>';
    if (dockBar) dockBar.style.width = Math.round(100 * (step + 1) / STEPS) + '%';
    if (step === 0) renderRooms();
    if (step === 1) renderTypes();
    if (step === 2) renderBudgets();
    if (step === 3) renderColours();
    if (step === STEPS) renderResults(true);
    refreshCount();
    if (opts.scroll !== false) {
      var top = $('.pdz-fd__stage').getBoundingClientRect().top + window.pageYOffset - 110;
      if (window.pageYOffset > top + 40 || opts.scroll === true) window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
    }
  }
  function next() { show(state.step + 1, { dir: 1, scroll: true }); }
  function back() { show(state.step - 1, { dir: -1, scroll: true }); }

  /* Step 1: room or department (tiles are rendered by Liquid, with counts and photos) */
  function renderRooms() {
    $$('.pdz-room').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-where') === state.where ? 'true' : 'false'); });
  }
  function whereLabel() {
    var b = root.querySelector('.pdz-room[data-where="' + (window.CSS && CSS.escape ? CSS.escape(state.where) : state.where) + '"]');
    return b ? b.getAttribute('data-label') : state.where;
  }

  /* Step 2: product types */
  var typesBox = $('[data-types]'), typesMore = $('[data-types-more]'), typeSearch = $('[data-type-search]');
  var typesAll = [], typesOpen = false, TYPES_SHOWN = 18;
  function renderTypes() {
    typesBox.setAttribute('aria-busy', 'true');
    if (!typesBox.children.length) typesBox.innerHTML = skeletonChips(12);
    load(state, 'type').then(function (d) {
      typesAll = values(d, P.type).filter(function (v) { return v.count > 0 && v.label && HIDE.indexOf(String(v.label).toLowerCase()) === -1; })
        .sort(function (a, b) { return b.count - a.count; });
      if (!d.byParam[P.type] || !typesAll.length) { available[1] = false; if (state.step === 1) show(2, { dir: 1 }); return; }
      drawTypes();
    }).catch(function () { typesBox.innerHTML = ''; }).then(function () { typesBox.removeAttribute('aria-busy'); });
  }
  function drawTypes() {
    var term = (typeSearch.value || '').trim().toLowerCase();
    var list = typesAll.filter(function (v) { return !term || v.label.toLowerCase().indexOf(term) > -1; });
    // chosen types always stay visible
    var chosen = list.filter(function (v) { return state.type.indexOf(v.value) > -1; });
    var rest = list.filter(function (v) { return state.type.indexOf(v.value) === -1; });
    var limit = typesOpen || term ? rest.length : Math.max(0, TYPES_SHOWN - chosen.length);
    var shown = chosen.concat(rest.slice(0, limit));
    typesBox.innerHTML = shown.length ? shown.map(function (v, i) {
      var on = state.type.indexOf(v.value) > -1;
      return '<button type="button" class="pdz-chip2" style="--i:' + i + '" data-type="' + esc(v.value) + '" aria-pressed="' + on + '">' +
        '<span>' + esc(v.label) + '</span><em>' + nf(v.count) + '</em></button>';
    }).join('') : '<p class="pdz-fd__none">No product type matches “' + esc(term) + '”.</p>';
    var hidden = rest.length - limit;
    typesMore.hidden = hidden <= 0;
    typesMore.textContent = 'Show all ' + nf(list.length) + ' types';
  }

  /* Step 3: budget */
  var budgetBox = $('[data-budgets-list]');
  function ranges() {
    var r = [], prev = 0;
    BUDGETS.forEach(function (b) { r.push([prev, b]); prev = b; });
    r.push([prev, 0]);
    return r;
  }
  function rangeLabel(r) {
    if (!r[0]) return 'Under R' + nf(r[1]);
    if (!r[1]) return 'R' + nf(r[0]) + ' and up';
    return 'R' + nf(r[0]) + ' to R' + nf(r[1]);
  }
  function renderBudgets() {
    var rs = ranges();
    budgetBox.innerHTML = rs.map(function (r, i) {
      var key = (r[0] || '') + '-' + (r[1] || '');
      return '<button type="button" class="pdz-budget" style="--i:' + i + '" data-price="' + key + '" aria-pressed="' + (state.price === key) + '">' +
        '<span class="pdz-budget__bars" aria-hidden="true">' + bars(i, rs.length) + '</span>' +
        '<strong>' + rangeLabel(r) + '</strong><small data-count>&nbsp;</small></button>';
    }).join('');
    rs.forEach(function (r) {
      var key = (r[0] || '') + '-' + (r[1] || '');
      load(withState({ price: key })).then(function (d) {
        var b = budgetBox.querySelector('[data-price="' + key + '"]');
        if (!b) return;
        b.querySelector('[data-count]').textContent = d.count ? nf(d.count) + ' products' : 'No products';
        b.disabled = !d.count;
      }).catch(function () {});
    });
  }
  function bars(i, n) {
    var out = '';
    for (var k = 0; k < n; k++) out += '<i class="' + (k <= i ? 'on' : '') + '" style="height:' + (30 + 70 * (k + 1) / n) + '%"></i>';
    return out;
  }

  /* Step 4: colour */
  var colourBox = $('[data-colours]');
  function renderColours() {
    colourBox.setAttribute('aria-busy', 'true');
    if (!colourBox.children.length) colourBox.innerHTML = skeletonChips(8);
    load(state, 'colour').then(function (d) {
      var vs = colourParam ? values(d, colourParam).filter(function (v) { return v.count > 0; }) : [];
      if (vs.length < 2) { available[3] = false; colourBox.innerHTML = ''; if (state.step === 3) show(STEPS, { dir: 1 }); return; }
      vs.forEach(function (v) { colourLabels[v.value] = v.label; });
      colourBox.innerHTML = vs.map(function (v, i) {
        var on = state.colour.indexOf(v.value) > -1;
        var dot = v.img ? 'background-image:url(' + v.img + ')' : v.color ? 'background:' + v.color : '';
        var multi = /multi|assorted/i.test(v.label) ? ' is-multi' : '';
        var light = /white|clear|cream|beige|ivory|silver|yellow/i.test(v.label) ? ' is-light' : '';
        return '<button type="button" class="pdz-swatch' + multi + light + '" style="--i:' + i + '" data-colour="' + esc(v.value) + '" aria-pressed="' + on + '">' +
          '<span class="pdz-swatch__dot" style="' + dot + '"></span><strong>' + esc(v.label) + '</strong><small>' + nf(v.count) + '</small></button>';
      }).join('');
    }).catch(function () { colourBox.innerHTML = ''; }).then(function () { colourBox.removeAttribute('aria-busy'); });
  }

  /* Results */
  var grid = $('[data-res-grid]'), moreBtn = $('[data-res-more]'), empty = $('[data-res-empty]');
  var resTitle = $('[data-res-title]'), resAll = $('[data-res-all]'), summary = $('[data-summary]');
  var page = 1, resReq = 0;
  function resultsUrl(p) {
    var q = filterQuery(state);
    q.set('sort_by', 'best-selling');
    if (p > 1) q.set('page', p);
    return '/collections/' + encodeURIComponent(state.where) + '?' + q.toString();
  }
  function renderResults(reset) {
    var my = ++resReq;
    if (reset) {
      page = 1;
      grid.innerHTML = '<ul class="pdz-grid pdz-grid--skeleton" aria-hidden="true">' + new Array(11).join('<li><span></span></li>') + '</ul>';
      empty.hidden = true; moreBtn.hidden = true;
      drawSummary();
    }
    resAll.href = resultsUrl(1);
    moreBtn.disabled = true;
    fetch(resultsUrl(page) + '&section_id=pdz-gift-results', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (my !== resReq) return;
        var gr = new DOMParser().parseFromString(html, 'text/html').querySelector('.pdz-gr');
        var n = gr ? Number(gr.getAttribute('data-count')) : 0;
        var list = gr && gr.querySelector('.pdz-grid');
        var items = list ? Array.prototype.slice.call(list.children) : [];
        items.forEach(function (li, i) { li.style.setProperty('--i', i % 24); li.classList.add('pdz-fd__card'); });
        if (page === 1) {
          grid.innerHTML = '';
          var ul = document.createElement('ul'); ul.className = 'pdz-grid'; grid.appendChild(ul);
        }
        var target = grid.querySelector('.pdz-grid');
        items.forEach(function (li) { target.appendChild(li); });
        var shown = target.children.length;
        resTitle.textContent = n ? (n === 1 ? '1 product matches' : nf(n) + ' products match') : 'No matches yet';
        empty.hidden = n > 0;
        moreBtn.hidden = shown >= n || !items.length;
        moreBtn.textContent = 'Show more (' + nf(n - shown) + ' left)';
        moreBtn.disabled = false;
      })
      .catch(function () { if (my === resReq) { grid.innerHTML = ''; empty.hidden = false; } });
  }
  function drawSummary() {
    var chips = [];
    if (state.where) chips.push(['where', state.where, whereLabel()]);
    state.type.forEach(function (t) { chips.push(['type', t, t]); });
    if (state.price) { var r = state.price.split('-'); chips.push(['price', state.price, rangeLabel([Number(r[0]) || 0, Number(r[1]) || 0])]); }
    state.colour.forEach(function (c) { chips.push(['colour', c, colourLabels[c] || c]); });
    summary.innerHTML = chips.length ? '<span class="pdz-fd__sum-lbl">You picked:</span>' + chips.map(function (c) {
      return '<button type="button" class="pdz-pick" data-drop="' + c[0] + '" data-val="' + esc(c[1]) + '" aria-label="Remove ' + esc(c[2]) + '">' + esc(c[2]) +
        '<svg width="12" height="12" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"/></svg></button>';
    }).join('') : '';
  }
  var colourLabels = {};

  /* ---------- helpers ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function skeletonChips(n) { var o = ''; for (var i = 0; i < n; i++) o += '<span class="pdz-chip2 is-ghost" style="width:' + (90 + (i * 37) % 80) + 'px"></span>'; return o; }
  function toggle(list, v) { var i = list.indexOf(v); if (i > -1) list.splice(i, 1); else list.push(v); }
  function pulse(el) { if (reduce || !el) return; el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop'); }

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('.pdz-room'))) {
      if (t.disabled) return;
      var w = t.getAttribute('data-where');
      var changed = state.where !== w;
      state.where = w;
      if (changed) { state.type = []; state.price = ''; state.colour = []; colourParam = ''; typesOpen = false; typeSearch.value = ''; available = { 1: true, 2: true, 3: true }; typesBox.innerHTML = ''; colourBox.innerHTML = ''; }
      $$('.pdz-room').forEach(function (b) { b.setAttribute('aria-pressed', b === t ? 'true' : 'false'); });
      pulse(t);
      refreshCount();
      setTimeout(next, reduce ? 0 : 280);
      return;
    }
    if ((t = e.target.closest('[data-type]'))) {
      toggle(state.type, t.getAttribute('data-type'));
      state.colour = [];
      t.setAttribute('aria-pressed', state.type.indexOf(t.getAttribute('data-type')) > -1);
      pulse(t); refreshCount(); writeUrl();
      return;
    }
    if ((t = e.target.closest('[data-price]'))) {
      var k = t.getAttribute('data-price');
      state.price = state.price === k ? '' : k;
      state.colour = [];
      $$('[data-price]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-price') === state.price); });
      pulse(t); refreshCount();
      if (state.price) setTimeout(next, reduce ? 0 : 280);
      return;
    }
    if ((t = e.target.closest('[data-colour]'))) {
      var c = t.getAttribute('data-colour');
      colourLabels[c] = (t.querySelector('strong') || {}).textContent || c;
      toggle(state.colour, c);
      t.setAttribute('aria-pressed', state.colour.indexOf(c) > -1);
      pulse(t); refreshCount(); writeUrl();
      return;
    }
    if (e.target.closest('[data-skip]')) {
      if (state.step === 1) state.type = [];
      if (state.step === 2) state.price = '';
      if (state.step === 3) state.colour = [];
      next(); return;
    }
    if (e.target.closest('[data-next]')) { next(); return; }
    if (e.target.closest('[data-back]')) { back(); return; }
    if ((t = e.target.closest('[data-goto]'))) { if (!t.disabled) show(Number(t.getAttribute('data-goto')), { dir: -1, scroll: true }); return; }
    if (e.target.closest('[data-types-more]')) { typesOpen = true; drawTypes(); return; }
    if (e.target.closest('[data-res-more]')) { page++; renderResults(false); return; }
    if (e.target.closest('[data-restart]')) {
      state = { where: '', type: [], price: '', colour: [], step: 0 }; colourParam = '';
      typesBox.innerHTML = ''; colourBox.innerHTML = '';
      typeSearch.value = ''; typesOpen = false; available = { 1: true, 2: true, 3: true };
      show(0, { scroll: true }); return;
    }
    if ((t = e.target.closest('[data-drop]'))) {
      var what = t.getAttribute('data-drop'), val = t.getAttribute('data-val');
      if (what === 'where') { state.where = ''; state.type = []; state.price = ''; state.colour = []; show(0, { scroll: true }); return; }
      if (what === 'type') toggle(state.type, val);
      if (what === 'price') state.price = '';
      if (what === 'colour') toggle(state.colour, val);
      writeUrl(); refreshCount(); renderResults(true);
    }
  });
  var searchTimer;
  typeSearch.addEventListener('input', function () { clearTimeout(searchTimer); searchTimer = setTimeout(drawTypes, 120); });
  typeSearch.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    var first = typesBox.querySelector('[data-type][aria-pressed="false"]');
    if (first) first.click();
  });

  /* start */
  if (state.colour.length) load(state, 'colour').then(function (d) {
    if (colourParam) values(d, colourParam).forEach(function (v) { colourLabels[v.value] = v.label; });
    show(state.step, { scroll: false });
  }, function () { show(state.step, { scroll: false }); });
  else show(state.step, { scroll: false });
})();
